import { IImageSize } from './i-image-size';

export interface IImage {
  id: string;
  url: string;
  sizes: IImageSize[];
}
